import { Directive } from '@angular/core';

@Directive({
  selector: '[appCustomCurrencyMask]',
  host: {
    '(keyup)': 'changeValue($event)',
    '(ionChange)': 'changeValue($event)',
  }
})
export class CustomCurrencyMaskDirective {

  changeValue(event) {
    let value = event.target.value;
    if (value == '') {
        return;
    }
    value = value + '';
    value = parseInt(value.replace(/[\D]+/g, ''));
    value = value + '';
    value = value.replace(/([0-9]{0})$/g, '.' + '$1');
    var parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    event.target.value = value.replace('.', '');
    return true;
  }

  constructor() { }
}

